import type { TFunction } from 'i18next';

import { ApiError } from './api';

/**
 * Превращает любую ошибку в текст, понятный человеку.
 * Сервер отдаёт код — перевод выбирается здесь, поэтому сообщения
 * одинаковы на русском и английском и не зависят от языка бэкенда.
 */
export function errorMessage(error: unknown, t: TFunction): string {
  if (error instanceof ApiError) {
    const details = (error.details ?? {}) as Record<string, unknown>;
    const translated = t(`errors:${error.code}`, { ...details, defaultValue: '' });
    if (translated) return translated;
    return error.message;
  }

  if (error instanceof TypeError) {
    // fetch бросает TypeError, когда сервер недоступен
    return t('errors:NETWORK');
  }

  if (error instanceof Error) return error.message;
  return t('errors:INTERNAL_ERROR');
}

/**
 * Ошибки конкретных полей формы — чтобы подсветить поле, а не показывать
 * общее «проверьте форму».
 */
export function fieldErrors(error: unknown, t: TFunction): Record<string, string> {
  if (!(error instanceof ApiError) || !error.fields) return {};

  const result: Record<string, string> = {};
  for (const field of error.fields) {
    const key = field.path.replace(/^body\./, '');
    const translated = t(field.message, { defaultValue: '' });
    result[key] = translated || field.message;
  }
  return result;
}

/** Особый случай: сервер отверг пароль как слишком простой. */
export function isCommonPasswordError(error: unknown): boolean {
  return (
    error instanceof ApiError &&
    error.code === 'CONFLICT' &&
    (error.details as { reason?: string } | undefined)?.reason === 'passwordTooCommon'
  );
}
